import { useContext, useEffect, useState, KeyboardEvent } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { useTranslation } from 'react-i18next';
import { ENTER_KEY } from '../../../constants/general';
import Heading from '../../../generic-components/Heading';
import { getLimitsErrorResourceKey } from '../utils';
import { SendMoneyContext } from '../pages/SendMoney';

interface IAmountPageUserInput {
  setAmount: (amount: string) => void;
  setIsFormValid: (isFormValid: boolean) => void;
}

const STYLES = {
  WRAPPER: 'mt-[64px] flex justify-center flex-wrap',
  INPUT:
    'w-[260px] bg-bw00 h-[50px] outline-none font-metricRMedium text-[42px] text-bw07 text-center placeholder-bw04 border-b caret-action03 border-action03 mb-[16px]',
  INPUT_ERROR: 'w-full font-metricR text-center text-sm text-red02',
};

const AmountPageUserInput = ({ setAmount, setIsFormValid }: IAmountPageUserInput) => {
  const { t } = useTranslation();
  const [inputAmount, setInputAmount] = useState<string>('');
  const [formErrorKey, setFormErrorKey] = useState<string>('');
  const { lowestLimit } = useContext(SendMoneyContext);
  useEffect(() => {
    const convertedAmount = Number(inputAmount);
    if (!convertedAmount || convertedAmount <= 0) {
      setFormErrorKey('');
      setIsFormValid(false);
    } else if (convertedAmount > lowestLimit.value) {
      setFormErrorKey(getLimitsErrorResourceKey(lowestLimit?.key));
      setIsFormValid(false);
    } else {
      setFormErrorKey('');
      setIsFormValid(true);
      setAmount(inputAmount);
    }
  }, [inputAmount]);

  return (
    <div className={STYLES.WRAPPER}>
      <CurrencyInput
        id='AmountPageUserInput'
        name='amount-input'
        onKeyDown={(event: KeyboardEvent) => {
          if (!formErrorKey && event.key === ENTER_KEY) setAmount(inputAmount);
        }}
        className={STYLES.INPUT}
        placeholder='$0.00'
        defaultValue={0}
        decimalsLimit={2}
        prefix='$'
        maxLength={9}
        autoFocus
        onValueChange={(value) => setInputAmount(value || '')}
      />
      {formErrorKey && (
        <Heading
          testId='SendMoneyAmountPage-inputError'
          title={t(formErrorKey as any)}
          className={STYLES.INPUT_ERROR}
        />
      )}
    </div>
  );
};

export default AmountPageUserInput;
